import React, { useEffect, useState } from "react";
import "./packages.css";
import CreatePackageDialog from "../components/packages/CreatePackageDialog";

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("all");

  // 🔁 TEMP: replace with API call
  useEffect(() => {
    setPackages([
      {
        id: 1,
        name: "Bali Honeymoon",
        destination: "Bali",
        category: "Honeymoon",
        duration_days: 7,
        price_per_person: 1200,
        active: true,
        image_url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
        description: "Romantic getaway with luxury stays",
        highlights: ["Beach", "Luxury", "Candle Dinner"]
      }
    ]);
  }, []);

  const filteredPackages = packages.filter(pkg => {
    const matchesSearch =
      pkg.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pkg.destination.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory =
      filterCategory === "all" || pkg.category === filterCategory;

    return matchesSearch && matchesCategory && pkg.active;
  });

  return (
    <div className="packages-page">
      <div className="packages-header">
        <div>
          <h1>Travel Packages</h1>
          <p>Browse and manage travel packages</p>
        </div>
        <button className="primary-btn" onClick={() => setShowCreateDialog(true)}>
          + Create Package
        </button>
      </div>

      <div className="packages-filters">
        <div className="search-box">
          <input
            placeholder="Search packages..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select
          value={filterCategory}
          onChange={(e) => setFilterCategory(e.target.value)}
        >
          <option value="all">All Categories</option>
          <option value="Honeymoon">Honeymoon</option>
          <option value="Adventure">Adventure</option>
          <option value="Luxury">Luxury</option>
          <option value="Family">Family</option>
          <option value="Business">Business</option>
          <option value="Group Tour">Group Tour</option>
          <option value="Solo Travel">Solo Travel</option>
          <option value="Pilgrimage">Pilgrimage</option>
        </select>
      </div>

      <div className="packages-grid">
        {filteredPackages.map(pkg => (
          <div key={pkg.id} className="package-card">
            {pkg.image_url && (
              <div className="package-image">
                <img src={pkg.image_url} alt={pkg.name} />
              </div>
            )}

            <div className="package-body">
              <span className="badge">{pkg.category}</span>
              <h3>{pkg.name}</h3>

              <div className="package-meta">
                <span>📍 {pkg.destination}</span>
                <span>⏱ {pkg.duration_days} days</span>
              </div>

              <p className="description">{pkg.description}</p>

              <div className="highlights">
                {pkg.highlights?.slice(0, 3).map((h, i) => (
                  <span key={i}>{h}</span>
                ))}
              </div>

              <div className="package-footer">
                <div>
                  <small>Starting from</small>
                  <h2>${pkg.price_per_person}</h2>
                  <small>per person</small>
                </div>
                <button className="primary-btn small">View Details</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredPackages.length === 0 && (
        <div className="empty-state">
          <h3>No packages found</h3>
          <p>
            {searchTerm || filterCategory !== "all"
              ? "Try adjusting your filters"
              : "Start by creating your first package"}
          </p>
        </div>
      )}

      <CreatePackageDialog
        open={showCreateDialog}
        onClose={() => setShowCreateDialog(false)}
        onSubmit={(data) => console.log("Create package", data)}
      />
    </div>
  );
}
